module.exports = __webpack_public_path__ + "static/media/ex8.1f354fcc.mp3";